<template>
    <div>
        <van-notice-bar left-icon="volume-o" :scrollable="false" mode="closeable" v-if="noticeList.length > 0">
            <van-swipe
                vertical
                class="notice-swipe"
                :autoplay="5000"
                :show-indicators="false"
            >
                <van-swipe-item @click="handleShowNotice(notice)" v-for="notice in noticeList" :key="notice.id">{{ notice.title }}</van-swipe-item>
            </van-swipe>
        </van-notice-bar>
        <van-popup v-model="visible" round position="bottom" closeable>
            <div class="intercession-header">反馈信息</div>
            <van-form validate-first @submit="handleSubmit">
                <van-field name="type" label="反馈类型" required :rules="[{ required: true, message: '请输入选择反馈类型' }]">
                    <template #input>
                        <van-radio-group v-model="form.type" direction="horizontal">
                            <van-radio name="suggestion">意见建议</van-radio>
                            <van-radio name="bug">Bug 缺陷</van-radio>
                            <van-radio name="help">需要帮助</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field
                    name="content"
                    required
                    size="large"
                    v-model="form.content"
                    type="textarea"
                    maxlength="500"
                    row="5"
                    show-word-limit
                    label="反馈内容"
                    placeholder="请输入反馈内容"
                    :rules="[{ required: true, message: '请输入反馈内容' }]"
                >
                </van-field>
                <van-field name="uploader" label="问题截图">
                    <template #input>
                        <ImageUploader @done="onImageUploadSuccess" upload-type="images" :max-count="2" />
                    </template>
                </van-field>

                <div style="margin: 16px;">
                    <van-button round block type="info" native-type="submit" :loading="loading">提交</van-button>
                </div>
            </van-form>
        </van-popup>
    </div>
</template>

<script>
import { Dialog } from 'vant'
import { getBulletinList, storeFeedback } from '@/api/common'
import ImageUploader from '@/components/ImageUploader'
export default {
    name: "Bulletin",
    components: { ImageUploader },
    data() {
        return {
            noticeList: [],
            visible: false,
            loading: false,
            form: {
                content: '',
                images: [],
                type: '',
                channel: 'h5'
            }
        }
    },
    methods: {
        handleSubmit () {
            this.loading = true
            storeFeedback(this.form).then(res => {
                this.$notify({ type: 'success', message: res.message })
                this.visible = false
            }).finally(() => {
                this.loading = false
            })
        },
        handleShowNotice (notice) {
            if (notice.type === 'common') {
                Dialog.alert({
                    messageAlign: 'left',
                    title: notice.title,
                    message: notice.content,
                    showCancelButton: true,
                    showConfirmButton: false,
                    cancelButtonText: '关闭'
                })
                return
            }
            if (notice.type === 'feedback') {
                this.visible = true
            }
        },
        onImageUploadSuccess (url) {
            this.form.images.push(url)
        }
    },
    created() {
        getBulletinList().then(res => {
            this.noticeList = res.data
        })
    }
}
</script>

<style scoped>
.notice-swipe {
    height: 40px;
    line-height: 40px;
}
</style>
